import 'aws-sdk/lib/credentials/cognito_identity_credentials';
import AWS, { CognitoIdentityCredentials } from 'aws-sdk/global';
import config from 'lib/config';

AWS.config.region = 'us-east-1';

// Instantiate it within the function so we can mock it during tests
const credentials = new CognitoIdentityCredentials({
  IdentityPoolId: config.cognitioIdentityPoolId,
  AccountId: '400329419115',
  RoleArn: config.cognitoRoleArn,
});

export default credentials;
